export const accessToken = (state) => {
    if(state.loginData){
        return state.loginData.accessToken;
    }
    return null;
}